module.exports = __webpack_public_path__ + "img/bau_logo_new.720cb0c0.png";